import { render, staticRenderFns } from "./LinkPOtoOT.vue?vue&type=template&id=5a5c9cb5&"
import script from "./LinkPOtoOT.vue?vue&type=script&lang=js&"
export * from "./LinkPOtoOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports